/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { IncomingTransactionDto } from '../../models/incoming-transaction-dto';
import { NotificationMessage } from '../../models/notification-message';

export interface ApiTransactionPost$Params {
  'api-version'?: string;
      body?: IncomingTransactionDto
}

export function apiTransactionPost(http: HttpClient, rootUrl: string, params?: ApiTransactionPost$Params, context?: HttpContext): Observable<StrictHttpResponse<NotificationMessage>> {
  const rb = new RequestBuilder(rootUrl, apiTransactionPost.PATH, 'post');
  if (params) {
    rb.query('api-version', params['api-version'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<NotificationMessage>;
    })
  );
}

apiTransactionPost.PATH = '/api/transaction';
